export default __webpack_public_path__ + "static/media/README-postman_SS.0d396577.md";